export default {
  iconGalleryImage: "/static/icons/icons_gallery_white.svg"
};
